<template>
  <v-layout fill-height column class="travel-complete">
    <v-layout flex-fill column justify-center>
      <v-container>
        <div class="travel-complete-img">
          <v-img :src="getImage(guideInfo.cheerup)" contain width="150px" class="mx-auto" />
        </div>
        <div class="fs-20 fw-600 mb-4">여행을 완전히 마치셨네요!<br>더 성장한 모습을 보니 무척 기뻐요.</div>
        <div class="fs-14 secondary--text fw-300">회원님을 위한 무궁무진한 여행이 준비되어있답니다.<br>기대해주세요!</div>
      </v-container>
    </v-layout>
    <div class="footer-btns">
      <BlackBtn x-large str="확인" @click="next" />
    </div>
  </v-layout>
</template>
<script>
// import store from '@/store'
import BlackBtn from "@/components/btns/BlackBtn"
import { mixinRemote, mixinReward, mixinTrial } from '@/mixins'
import store from '@/store'

export default {
  components: {
    BlackBtn
  },
  mixins: [ mixinRemote, mixinReward, mixinTrial ],
  data: () => ({}),
  created() {
  },
  computed: {
    ordDtlNo() {
      return this.$route.params.ordDtlNo ? this.$route.params.ordDtlNo : store.getters.useOrdDtl.ordDtlNo
    },
    showGuideEvaluation() {
      return this.$route.params.showGuideEvaluation
    }
  },
  methods: {
    async next() {
      let params = {
        ordDtlNo: this.ordDtlNo
      }
      await store.dispatch('updateSltUseCmplt',  this.$_payload('suSltUse', params))
        .then(res => {
          if (res.success) {
            // 완료뱃지
            this.insertMemberBadgePoss(9, 1)
            // this.$root.$children[0].$refs.content.$emit('insertMemberBadgePoss', 9,1)
            // 완료코인
            this.insertMemberCoin(this.$store.state.auth.authUser.userKey, 20, '0009', this.ordDtlNo)
            // this.$root.$children[0].$refs.content.$emit('insertMemberCoin', this.$store.state.auth.authUser.userKey, 20, '0009', this.ordDtlNo)

            if (store.state.client.contract.allowsRealtalkService && this.showGuideEvaluation === 'Y') {
              /* 가이드 평가 */
              this.$router.push({name: '가이드 평가', params: {'ordDtlNo': this.ordDtlNo}})
            } else {
              if (this.endedTrial) {
                this.movePage('/fo/myTicket');
              } else {
                this.$router.push('/')
              }
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.travel-complete {
  text-align: center;
  &-img {
    padding-top: 90px;
    margin-bottom: 20px;
    background: url("~@/assets/images/particle.svg") center top 0 no-repeat;
    background-size: auto 125px;
  }
}
</style>
